var _g, _path, _rect, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 8.06636C3 6.9908 3.43315 5.96055 4.20171 5.20811L7.33378 2.14175C8.08135 1.40987 9.08589 1 10.1321 1H21C23.2091 1 25 2.79086 25 5V25C25 27.2091 23.2091 29 21 29H7C4.79086 29 3 27.2091 3 25V8.06636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 8.06636C3 6.9908 3.43315 5.96055 4.20171 5.20811L7.33378 2.14175C8.08135 1.40987 9.08589 1 10.1321 1H21C23.2091 1 25 2.79086 25 5V25C25 27.2091 23.2091 29 21 29H7C4.79086 29 3 27.2091 3 25V8.06636Z",
    stroke: "#828896"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1V4C9 5.65685 7.65685 7 6 7H3",
    stroke: "#828896",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11,
    width: 19,
    height: 10,
    rx: 2,
    fill: "#19B0F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1705 13.4091L13.1971 15.1442H13.2369L14.2685 13.4091H15.484L13.9304 15.9545L15.5188 18.5H14.2809L13.2369 16.7624H13.1971L12.1531 18.5H10.9201L12.5135 15.9545L10.9499 13.4091H12.1705ZM16.1651 18.5V13.4091H17.2415V17.6126H19.424V18.5H16.1651ZM22.8985 14.8732C22.8786 14.6727 22.7933 14.5169 22.6425 14.4059C22.4917 14.2949 22.287 14.2393 22.0285 14.2393C21.8528 14.2393 21.7045 14.2642 21.5835 14.3139C21.4626 14.362 21.3698 14.4291 21.3051 14.5153C21.2422 14.6014 21.2107 14.6992 21.2107 14.8086C21.2074 14.8997 21.2264 14.9793 21.2678 15.0472C21.3109 15.1152 21.3698 15.174 21.4443 15.2237C21.5189 15.2718 21.6051 15.314 21.7029 15.3505C21.8006 15.3853 21.905 15.4151 22.0161 15.44L22.4735 15.5494C22.6955 15.5991 22.8994 15.6654 23.085 15.7482C23.2706 15.8311 23.4313 15.933 23.5672 16.054C23.7031 16.175 23.8083 16.3175 23.8829 16.4815C23.9591 16.6456 23.9981 16.8337 23.9997 17.0458C23.9981 17.3574 23.9185 17.6275 23.7611 17.8562C23.6053 18.0832 23.3799 18.2597 23.085 18.3857C22.7916 18.5099 22.4378 18.5721 22.0235 18.5721C21.6125 18.5721 21.2546 18.5091 20.9497 18.3832C20.6464 18.2572 20.4094 18.0708 20.2387 17.8239C20.0697 17.5753 19.981 17.2679 19.9727 16.9016H21.0143C21.0259 17.0723 21.0748 17.2148 21.161 17.3292C21.2488 17.4419 21.3656 17.5272 21.5115 17.5852C21.6589 17.6416 21.8255 17.6697 22.0111 17.6697C22.1934 17.6697 22.3517 17.6432 22.4859 17.5902C22.6218 17.5372 22.727 17.4634 22.8016 17.369C22.8762 17.2745 22.9134 17.166 22.9134 17.0433C22.9134 16.929 22.8795 16.8329 22.8115 16.755C22.7452 16.6771 22.6475 16.6108 22.5182 16.5561C22.3906 16.5014 22.234 16.4517 22.0484 16.407L21.4941 16.2678C21.0648 16.1634 20.7259 16.0001 20.4774 15.7781C20.2288 15.556 20.1053 15.2569 20.107 14.8807C20.1053 14.5724 20.1874 14.3031 20.3531 14.0728C20.5204 13.8424 20.75 13.6626 21.0416 13.5334C21.3333 13.4041 21.6647 13.3395 22.036 13.3395C22.4138 13.3395 22.7436 13.4041 23.0253 13.5334C23.3087 13.6626 23.5291 13.8424 23.6865 14.0728C23.844 14.3031 23.9252 14.57 23.9301 14.8732H22.8985Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_30",
    x: -22.5,
    y: -14.5,
    width: 73,
    height: 79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1_30"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_30"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_30",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.2663b8a9915fecafb2430921c91c24fc.svg";
export { ForwardRef as ReactComponent };